<template>
    <div>
        <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-form-item label="考勤组名称" prop="checkAttendance_name">
                <el-input v-model="form.checkAttendance_name" style="width: 90%;" placeholder="请输入考勤组名称"></el-input>
            </el-form-item>
            <el-form-item label="上班时间" prop="work_shift">
                <el-time-picker arrow-control v-model="form.work_shift" placeholder="请选择上班时间" format="HH:mm"
                    value-format="HH:mm" style="width: 90%;">
                </el-time-picker>
            </el-form-item>
            <el-form-item label="下班时间" prop="closing_time">
                <el-time-picker arrow-control v-model="form.closing_time" placeholder="请选择下班时间" format="HH:mm"
                    value-format="HH:mm" style="width: 90%;">
                </el-time-picker>
            </el-form-item>
            <el-form-item label="休息开始时间" prop="restStart_time">
                <el-time-picker arrow-control v-model="form.restStart_time" placeholder="请选择休息开始时间" format="HH:mm"
                    value-format="HH:mm" style="width: 90%;">
                </el-time-picker>
            </el-form-item>
            <el-form-item label="休息结束时间" prop="restEnd_time">
                <el-time-picker arrow-control v-model="form.restEnd_time" placeholder="请选择休息结束时间" format="HH:mm"
                    value-format="HH:mm" style="width: 90%;">
                </el-time-picker>
            </el-form-item>
            <el-form-item label="出勤人" prop="attendants">
                <div @click="setStaff">
                    <el-input v-model="form.attendants_name" style="width: 90%;" placeholder="请选择出勤人"
                        onfocus="this.blur();"></el-input>
                </div>
            </el-form-item>
            <el-form-item label-width="0" style="text-align: center;">
                <el-button type="primary" style="background-color: #006E4B; border: 1px #006E4B solid; width: 100px;"
                    v-show="form.id == null || form.id == ''" @click="Add">保存</el-button>
                <el-button type="primary" style="background-color: #006E4B; border: 1px #006E4B solid; width: 100px;"
                    v-show="form.id != null && form.id != ''" @click="Update">修改</el-button>
            </el-form-item>
        </el-form>

        <el-dialog title="选择出勤人" :visible.sync="dialogVisible" width="40%" :center="true" :close-on-click-modal="false"
            :show-close="false" append-to-body>
            <setStaff ref="setStaff" :from="setStaff"></setStaff>
        </el-dialog>
    </div>
</template>

<script>
    import setStaff from "./KqzGl_add_setStaff.vue";
    export default {
        components: {
            setStaff: setStaff,
        },
        data() {
            return {
                //表单数据
                form: {
                    id: "",
                    checkAttendance_name: "",
                    work_shift: "",
                    closing_time: "",
                    restStart_time: "",
                    restEnd_time: "",
                    attendants: "",
                    attendants_name: "",
                },

                //表单验证
                rules: {
                    checkAttendance_name: [{
                        required: true,
                        message: '请输入考勤组名称！',
                        trigger: 'blur'
                    }],
                    work_shift: [{
                        required: true,
                        message: '请选择上班时间！',
                        trigger: 'blur'
                    }],
                    closing_time: [{
                        required: true,
                        message: '请选择下班时间！',
                        trigger: 'blur'
                    }],
                    restStart_time: [{
                        required: true,
                        message: '请选择休息开始时间！',
                        trigger: 'blur'
                    }],
                    restEnd_time: [{
                        required: true,
                        message: '请选择休息结束时间！',
                        trigger: 'blur'
                    }],
                    attendants: [{
                        required: true,
                        message: '请选择出勤人！',
                        trigger: 'blur'
                    }],
                },

                //页面相关
                dialogVisible: false,
            };
        },
        methods: {
            //添加操作
            Add() {
                this.$refs["ruleForm"].validate(async (valid) => {
                    if (valid) {
                        var url = 'attendanceGroup/add';
                        var record = {
                            checkAttendance_name: this.form.checkAttendance_name,
                            work_shift: this.form.work_shift,
                            closing_time: this.form.closing_time,
                            restStart_time: this.form.restStart_time,
                            restEnd_time: this.form.restEnd_time,
                            attendants: this.form.attendants,
                        };
                        var data = await this.$globals.AxiosPost(url, record);
                        if (data === '-2000') {
                            this.$message.error('服务器未响应！请稍后重试');
                        } else {
                            var code = data.code;
                            var data = data.data;
                            if (code === '200') {
                                this.$message.success(data);
                                this.$parent.$parent.Return();
                            } else {
                                this.$message.warning(data);
                            }
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            //修改操作
            Update() {
                this.$refs["ruleForm"].validate(async (valid) => {
                    if (valid) {
                        var url = 'attendanceGroup/modify';
                        var record = {
                            id: this.form.id,
                            checkAttendance_name: this.form.checkAttendance_name,
                            work_shift: this.form.work_shift,
                            closing_time: this.form.closing_time,
                            restStart_time: this.form.restStart_time,
                            restEnd_time: this.form.restEnd_time,
                            attendants: this.form.attendants,
                        };
                        var data = await this.$globals.AxiosPost(url, record);
                        if (data === '-2000') {
                            this.$message.error('服务器未响应！请稍后重试');
                        } else {
                            var code = data.code;
                            var data = data.data;
                            if (code === '200') {
                                this.$message.success(data);
                                this.$parent.$parent.Return();
                            } else {
                                this.$message.warning(data);
                            }
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            //设置人员
            setStaff() {
                this.dialogVisible = true;
            }
        },
        created() {
            this.form = this.$parent.$parent.form;
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// KqzGl_add.vue?1facf157